import { ModulesFormRegistryEntry } from '../../../contexts'

import { iframeFactory } from '../Iframe.factory'

export const iframeModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './Iframe.form.vue'
  ),
  factory: iframeFactory,
  icon: require('../iframe.svg'),
  label: 'modulesForms.Iframe._name',
  priority: 20
}
